///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2020
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React from "react";

import messages from "../../helpers/messages";

export const ExclamationIcon = ({
  height,
  fill = "#FFFFFF",
  title = messages.exclamation.defaultMessage,
  width,
  secondaryColor = "#B00020",
  ...rest
}) => (
  <svg
    aria-labelledby="exclamation-icon"
    width={width}
    height={height}
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 36 36"
    {...rest}
  >
    <title id="exclamation-icon">{title}</title>
    <defs>
      <clipPath id="exclamation-icon-clip-path">
        <path
          d="M16 32A16 16 0 014.688 4.688 16 16 0 1116 32zm-1.6-11.2V24h3.2v-3.2zm0-12.8v9.6h3.2V8z"
          transform="translate(4 4)"
          fill={fill}
        />
      </clipPath>
    </defs>
    <path d="M0 0h39v39H0z" fill="none" />
    <path
      data-name="Mask"
      d="M20 36A16 16 0 018.688 8.688 16 16 0 1120 36zm-1.6-11.2V28h3.2v-3.2zm0-12.8v9.6h3.2V12z"
      fill={fill}
    />
    <g data-name="Alert/ic_error" clipPath="url(#exclamation-icon-clip-path)">
      <path fill={secondaryColor} d="M0 0h39v39H0z" data-name="↳ 🎨Color" />
    </g>
  </svg>
);

export default ExclamationIcon;
